import React from 'react';
import { withPlaceholder, Text, Image } from '@sitecore-jss/sitecore-jss-react';
import LargerImageTextBlock from '@component/LargerImageTextBlock';

const LargerImageTextBlockComponent = (props) => {
  const themeObject = props.params.buttonvariant === undefined ? '' : JSON.parse(props.params.buttonvariant);
  const buttonColor = themeObject?.Color === undefined ? 'secondary' : themeObject?.Color.value;
  const target = props.fields?.link?.value?.target === '' ? '_self' : props.fields?.link?.value?.target;
  return (
    <>
      <LargerImageTextBlock
        image={<Image field={props.fields?.image} editable={true} />}
        Title={<Text field={props.fields.title} />}
        body={<Text field={props.fields?.description} />}
        cta={props.fields?.linktext.value}
        buttonVariant={buttonColor}
        handleClick={() => {
          window.open(props.fields?.link?.value?.href, target);
        }}
        ctalink={props.fields?.link?.value?.href}
      />
    </>
  );
};
export default withPlaceholder('larger-image-text')(LargerImageTextBlockComponent);
